import { useMemo } from "react";
import { parserDateByListFormat, DAYJS_VALID_FORMAT_TIMES } from "utils/date";
import { PickerMode, PICKER_MODE } from "../constants";

/**
 * Hook to manage input validation
 */
export const useInputValidation = (mode: PickerMode, inputText: string) => {
  return useMemo(() => {
    if (!inputText?.trim()) return { isValid: true, parsedValue: null };

    if (mode === PICKER_MODE.DATE) {
      const parsedValue = parserDateByListFormat(inputText);

      return { isValid: !!parsedValue, parsedValue };
    } else {
      const parsedValue = parserDateByListFormat(inputText, DAYJS_VALID_FORMAT_TIMES);

      return { isValid: !!parsedValue, parsedValue };
    }
  }, [mode, inputText]);
};
